export default __webpack_public_path__ + "ui/assets/img/link-24.svg";